import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { commonImages } from '@images/common-images';
import { ApiService } from '@services/api/api.service';
import { ProjectService } from '@services/api/project.service';
import { SharedService } from '@services/api/shared.service';
import { TaskService } from '@services/api/task.service';
import { WorkflowService } from '@services/api/workflow.service';
import { AuthService } from '@services/auth.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { FormHelper } from '@services/helpers/form-helper';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { Utils } from '@services/helpers/utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { SharedSubjectService } from '@services/share-service';
import { SharedDataService } from '@services/shared-data.service';
import { ReduxService } from '@state-management/redux.service';
import { ToastrService } from 'ngx-toastr';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { environment } from 'src/environments/environment';
import { DashService } from '../../dash-board/dash.service';
import { Leads } from '../../leads-management/leads/leads';

@Component({
  selector: 'app-edit-task',
  templateUrl: './edit-task.component.html',
  styleUrls: ['./edit-task.component.scss'],
  providers: [SharedSubjectService],
})
export class EditTaskComponent implements OnInit {
  @Input() editId: any;
  @Input() isEditContact: any;

  @Output() isUpdated = new EventEmitter<any>();
  @Output() isTaskUpdate = new EventEmitter<boolean>();
  S3Path = environment.S3 + '/';
  common_images = commonImages;
  minDate = new Date();
  clicked = false;
  rexValid = true;
  editTaskForm: FormGroup;
  submitted: boolean = false;
  jobTypes: any;
  leads: any;
  projects: any;
  apartments: any;
  assignedUsers = [];
  assigns: any;
  shortContactCompany: any;
  contactsList: any;
  originalAssigns: any;
  taskStatuses: any;
  categories: any;
  properties: any;
  priorities: any;
  bill: any;
  file_name: any;
  uploadedFile: any;
  comments = '';
  commentList: any;
  showTab = 'comment';
  localUser: any = [];
  logList: any;
  taskUserID = null;
  userID = Crypto.decrypt(this.localStorageService.GetItem('uid'));
  public GroupFormData = new FormData();
  tasks: any;
  public logos = null;
  public logoUrl: any;
  commentSubmit = false;
  submit_btn_disabled = false;
  checkList = [];
  times = [];
  newItem = '';
  checkItemToEdit = null;
  dropdown_options = [
    { name: 'Contact', value: 'contact' },
    { name: 'Listing', value: 'property' },
    // { name: 'Lead Management', value: 'lead_management' },
    { name: 'Property', value: 'properties' },
    { name: 'Project', value: 'project' },
    { name: 'Lead Management', value: 'lead_management' },
    { name: 'Other', value: 'other' },
  ];
  reminder_options = Leads.reminder_options;
  timer_options = Leads.timer_options;
  subscription: any;
  showLeads = false;
  showProject = false;
  showContact = false;
  showProperty = false;
  error = null;
  @ViewChild('editFormElement') formElementRef!: ElementRef;
  notDisplayRequiredMessage: boolean = true;
  numOfNotValidFields: number = 0;
  requiredErrorMessages = [];
  formalFields: { name: string; label: string }[] = [];
  public user_permission = Crypto.decrypt(this.localStorageService.GetItem('_per'));
  public user_role = Crypto.decrypt(this.localStorageService.GetItem('role'));
  assignUser: any = [];
  isMobileDevice = false;
  show_filter = false;
  isShowChild: boolean = false;
  child_task_title = null;
  submittedBtn = false;
  child_task_list: any[] = [];
  taskRows: number = 15;
  taskScrollTop: number = 0;
  @ViewChild('taskScrollableElement') taskScrollableElement!: ElementRef;
  task_list: any[] = [];
  @Output() IsSavedClosed: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  selectedContact: any;
  currentLeadIndex: any;
  teams: any[] = [];

  constructor(
    private sds: SharedDataService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private localStorageService: LocalStorageService,
    private formHelper: FormHelper,
    private _taskService: TaskService,
    private _sharedService: SharedService,
    private toast: ToastrService,
    private api: ApiService,
    public projectService: ProjectService,
    private Auth: AuthService,
    private shareService: SharedSubjectService,
    public lmService: LeadManagementService,
    private _workflowService: WorkflowService,
    private _mobileService: DashService,
    private redux: ReduxService,
    private router: Router,
    private remmiConfirm: RemmiConfirmService
  ) {
    this.editForm();
    for (let hr = 0; hr < 24; hr++) {
      let zone = hr < 12 ? 'AM' : 'PM';
      let clock = hr > 12 ? hr % 12 : hr;
      let shr = clock < 10 ? '0' + clock : clock;
      shr = shr == '00' ? '12' : shr;
      let vhr = hr < 10 ? '0' + hr : hr;
      this.times.push({ label: shr + ':00 ' + zone, value: vhr + ':00' });
      this.times.push({ label: shr + ':30 ' + zone, value: vhr + ':30' });
    }
  }

  // This is the ngOnInit lifecycle hook, which is called when the component is initialized
  async ngOnInit() {
    // Wait for the 'getCreatingUser' function to finish before proceeding
    await this.getCreatingUser();

    // Fetch the office staff details
    this.getOfficeStaff();

    // Fetch the job types and sort them alphabetically by name
    this._taskService.getTypes({ office_id: this.api.getOfficeId() }).subscribe({
      next: response => {
        this.jobTypes = response.data?.sort((a, b) => a?.name.localeCompare(b?.name)); // Sort job types by name
      },
    });

    // Fetch the task statuses
    this._taskService.getStatuses({ office_id: this.api.getOfficeId() }).subscribe({
      next: response => {
        this.taskStatuses = response.data; // Store task statuses
      },
    });

    // Fetch the task priorities
    this._taskService.getPriorities({ office_id: this.api.getOfficeId() }).subscribe({
      next: response => {
        this.priorities = response.data; // Store task priorities
      },
    });

    // Load tasks based on the current setup
    this.loadTask();

    // Fetch the list of child tasks
    this.getChildTaskList();

    // Fetch the checklist associated with the task
    this.getCheckList();

    // Fetch the entity leads
    this.getEntityLeads();

    // Load the comments associated with the task
    this.loadComments();

    // Fetch the activity log related to the task
    this.getActivityLog();

    // Subscribe to changes in the user's office, and re-fetch the office staff if the default office changes
    this.subscription = this.Auth.getChangeUserOffice().subscribe({
      next: response => {
        if (response === 'change default office') {
          // After a short delay, re-fetch the office staff details
          setTimeout(() => {
            this.getOfficeStaff();
          }, 500); // 500ms delay
        }
      },
    });

    // Subscribe to the screen size changes (for responsive design)
    this._mobileService?.screenSize$?.subscribe({
      next: size => {
        // Toggle the 'isMobileDevice' property based on the screen width
        if (size.width < 667) {
          this.isMobileDevice = true; // Enable mobile toggle for small screen sizes
        } else {
          this.isMobileDevice = false; // Disable mobile toggle for larger screen sizes
        }
      },
    });
  }

  // Helper to set property_project_type safely
  setProjectType(type: string) {
    this.editTaskForm.controls['property_project_type'].setValue(type);
  }

  // Function to load a task by its ID
  loadTask = () => {
    // Fetch the task by its edit ID
    this._taskService.getTaskById(this.editId).subscribe({
      next: response => {
        // Set the task's user ID and data to the class properties
        this.taskUserID = response.data.user_id;
        this.tasks = response.data;

        // Reset flags (optional but recommended)
        this.showProject = false;
        this.showProperty = false;
        this.showLeads = false;
        this.showContact = false;

        // Handle project
        if (this.tasks?.project_id) {
          // this.setProjectType('project');
          this.getApartmentByProject(this.tasks.project_id);
        }

        // Handle property
        if (this.tasks?.property_id != null) {
          this.showProperty = true;
          this.setProjectType('property');
          this.editTaskForm.controls['property_id'].setValue([this.tasks.property_id]);
        }

        // Handle lead
        if (this.tasks?.lead_id != null) {
          this.showLeads = true;
          this.setProjectType('lead');
        }

        // Handle contact
        if (this.tasks?.contact_id != null) {
          this.showContact = true;
          this.setProjectType('contact');
        }

        // Handle multiple properties
        if (this.tasks?.properties_id != null) {
          this.setProjectType('properties_id');
          this.editTaskForm.controls['properties_id'].setValue([this.tasks.properties_id]);
        }

        if (this.tasks?.project_id != null) {
          this.setProjectType('project_id');
          this.editTaskForm.controls['project_id'].setValue([this.tasks.project_id]);
        }

        // Handle parent task
        if (this.tasks?.parent_id) {
          this.getAllTasks();
        }

        // Populate form controls
        Object.keys(this.editTaskForm.controls).forEach(key => {
          const value = response?.data?.[key];

          // Skip excluded fields
          const excludedFields = ['appraisal', 'start_date', 'due_date', 'recurringEnds'];

          if (!excludedFields.includes(key)) {
            this.editTaskForm.controls[key].setValue(value ?? null);
          }

          // Handle date fields
          if (['start_date', 'due_date', 'recurringEnds'].includes(key)) {
            this.editTaskForm.controls[key].setValue(value ? new Date(value) : null);
          }
        });

        // Check if the task has assigned users or teams, and update the form controls
        if (response.data.assignToUsers.data?.length > 0 || response.data.assignToTeams?.length > 0) {
          // Extract user and team IDs from the response
          let assign_id = response.data.assignToUsers?.data?.map(user_id => user_id?._id);
          let team_id = response.data.assignToTeams?.map(team => team?._id);
          // Patch the form with assigned users and teams
          this.editTaskForm.patchValue({
            assignedUsers: assign_id,
            assignedTeams: team_id,
            title: this.tasks?.title ?? null,
            job_type_id: this.tasks?.job_type_id ?? null,
            task_status_id: this.tasks?.task_status_id ?? null,
            project_id: this.tasks?.project_id ?? null,
            priority_id: this.tasks?.priority_id ?? null,
            lead_id: this.tasks?.lead_id ?? null,
            description: this.tasks?.description ?? null,
            task_time: this.tasks?.task_time ?? null,
            reminder: this.tasks?.reminder ?? null,
          });
          setTimeout(() => {
            this.showProject = true;
          }, 1000);
        }

        // If due_date is not set, assign an empty string to the due_date field
        !response.data['due_date'] && this.editTaskForm.controls['due_date'].setValue('');
        // If task_time is not set, assign null to the task_time field
        !response.data['task_time'] && this.editTaskForm.controls['task_time'].setValue(null);
        // If reminder is not set, assign null to the reminder field
        !response.data['reminder'] && this.editTaskForm.controls['reminder'].setValue(null);

        console.log('editTaskForm :>> ', this.editTaskForm?.value);
      },
    });
  };

  // Fetches the current user's details by ID
  getCreatingUser() {
    // Make an API call to fetch user details using the user ID
    this._taskService.getTaskCreatingUser().subscribe({
      next: response => {
        // Assign the user data to the local 'localUser' variable
        this.localUser = response?.data;
      },
    });
  }

  // Function to get checklists for a specific task by its ID
  getCheckList() {
    // Make an API call to fetch checklists for the task using its editId
    this._taskService.getTaskCheckList(this.editId).subscribe({
      next: response => {
        // For each checklist item returned by the API
        response.forEach(c => {
          // Push the sub-task name to the checkList array
          this.checkList.push(c.sub_task_name);
        });
      },
    });
  }

  // Function to validate if the job_type_id exists in the list of jobTypes
  isValidJobTypeId(): boolean {
    // Get the job_type_id value from the form control
    const jobTypeId = this.editTaskForm.controls['job_type_id'].value;

    // Check if the jobTypeId matches any of the jobTypes from the list
    let isMatched = this.jobTypes.some(jobType => jobType._id === jobTypeId);

    // If no match is found, set the job_type_id in the form to null
    if (!isMatched) {
      this.editTaskForm.controls['job_type_id'].setValue(null);
    }

    // Return true if matched, else false
    return isMatched;
  }

  // Function to save a new child task
  saveChildTask() {
    // Set the flag to indicate that the form has been submitted
    this.submittedBtn = true;

    // Check if the child task title is empty, show an error if true
    if (!this.child_task_title) {
      this.toast.error('Please add title for sub task');
      this.submittedBtn = false;
      return;
    }

    // Prepare the form data for the new task

    let form_data = {
      property_project_type: 'contact', // Type of project for the task
      title: this.child_task_title, // Title of the child task
      task_status_id: null, // Task status (null initially)
      due_date: this.editTaskForm.controls['due_date'].value, //this.editTaskForm.patchValue({ due_date: new Date() }), // Set current date as the due date
      priority_id: null, // Task priority (null initially)
      office_id: this.api.getOfficeId(), // Office ID from API
      parent_id: this.tasks._id, // ID of the parent task
      job_type_id: null, // Job type ID (null initially)
      is_sub_task: true, // Mark it as a sub-task
      is_later: 0, // Mark task as not scheduled for later
      assignedUsers: [], // No users assigned initially
      assignedTeams: [], // No teams assigned initially
      start_date: null, // No start date initially
      property_id: null, // No property ID initially
      properties_id: null, // No properties ID initially
      task_category_id: null, // No category ID initially
      description: '', // No description initially
      isRecurring: null, // Not a recurring task
      recurringType: null, // No recurring type
      recurringEnds: null, // No recurring end date
      logos: null, // No logos
      task_check_list: null, // No checklist initially
      lead_id: null, // No lead ID initially
      SaveToGoogleCalendar: null, // Not saving to Google Calendar
      contact_id: [], // No contact ID initially
      project_id: null, // No project ID initially
      apartment_id: null, // No apartment ID initially
      task_time: '9am', // Default task time
      reminder: '15 minutes', // Default reminder time
      time_zone: 'Asia/Karachi', // Time zone
    };

    // Make an API call to create the task
    this._taskService.createTask(form_data).subscribe({
      next: _ => {
        // Hide the child task form and reset the title
        this.isShowChild = false;
        this.child_task_title = null;

        // Show a success message and update the child task list
        this.toast.success('Task created');
        this.getChildTaskList();

        // Reset the submitted button flag
        this.submittedBtn = false;
      },
    });
  }

  // Function to scroll the task list to the top
  scrollTaskToTop(): void {
    // Get the scrollable element and set its scrollTop to 0 (top)
    const element = this.taskScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }

  // Function to handle scroll event on the task list
  onTaskScroll(event: Event): void {
    // Get the target element and update the scrollTop value
    const element = event.target;
    this.taskScrollTop = element['scrollTop'];
  }

  // Function to get the list of child tasks for a specific task
  getChildTaskList() {
    // Make an API call to get the child task details
    this._taskService.getChildTaskDetail(this.editId).subscribe({
      next: response => {
        // Reset the child task list
        this.child_task_list = [];

        // Map the response data to include an isOpen flag and update the list
        this.child_task_list = response?.data?.map(el => {
          return { ...el, isOpen: true };
        });
      },
    });
  }

  // Function to get all tasks based on office ID and user ID
  getAllTasks() {
    // Make an API call to fetch all tasks based on office ID and user ID
    this._sharedService.getDropDownItems('tasks').subscribe({
      next: response => {
        // Set the task list with the data fetched from the response
        this.task_list = response?.data;
      },
    });
  }

  // ngOnDestroy lifecycle hook to clean up resources when the component is destroyed
  ngOnDestroy() {
    // Reset the right bar reload flag to true
    this.lmService.reload_rightBar = true;

    // Clear the 'isEdit_show_div' value
    this.lmService.isEdit_show_div = null;

    // Unsubscribe from the subscription to prevent memory leaks
    this.subscription.unsubscribe();
  }

  editForm() {
    this.editTaskForm = this.fb.group({
      is_later: [0],
      title: ['', Validators.required],
      assignedTeams: [[]],
      assignedUsers: [[], Validators.required],
      job_type_id: [null, Validators.required],
      start_date: ['', Validators.required],
      due_date: ['', Validators.required],
      task_status_id: [null, Validators.required],
      property_id: [null],
      properties_id: [null],
      priority_id: [null],
      SaveToGoogleCalendar: [null],
      description: [''],
      isRecurring: [false],
      recurringType: [null],
      recurringEnds: [null],
      logos: [],
      lead_id: [null],
      task_check_list: [''],
      project_id: [],
      contact_id: [null],
      apartment_id: [null],
      property_project_type: ['property'],
      task_time: [null],
      reminder: [null],
      parent_id: [null],
      time_zone: [Intl.DateTimeFormat().resolvedOptions().timeZone],
    });
  }

  // Function to handle form submission
  onSubmit(state) {
    // Set the 'submitted' flag to true indicating the form is being submitted
    this.submitted = true;

    // Disable the submit button to prevent multiple submissions
    this.submit_btn_disabled = true;

    // Set the 'start_date' field to the current date and time
    this.editTaskForm.patchValue({
      start_date: new Date(),
    });

    // If the state is "later", set the 'is_later' field to 1, otherwise set it to 0
    if (state === 'later') {
      this.editTaskForm.controls['is_later'].setValue(1);
    } else {
      this.editTaskForm.controls['is_later'].setValue(0);
    }

    // Validate all form fields
    this.formHelper.validateAllFormFields(this.editTaskForm);

    // Collect the fields that are invalid in the form and store them in the 'fields' array
    let fields: any = Object.entries(this.editTaskForm.controls)
      .reduce((acc, [key, value]) => {
        if (value.status === 'INVALID') {
          acc.push(this.formalFields.find(errorfield => errorfield.name === key) || undefined);
        }
        return acc;
      }, [])
      ?.filter(error_field => error_field !== undefined && error_field !== null);

    // If there are invalid fields, validate them on the request
    fields && this.validateFieldsOnRequest(fields);

    // If the form is invalid, re-enable the submit button and exit the function
    if (this.editTaskForm.invalid) {
      this.submit_btn_disabled = false;
      return;
    }

    // Depending on the 'property_project_type' field value, set other fields to null
    if (this.editTaskForm.get('property_project_type').value == 'property') {
      this.editTaskForm.patchValue({ project_id: null, apartment_id: null });
    } else {
      if (this.editTaskForm.get('property_project_type').value == 'contact') {
        this.editTaskForm.patchValue({ project_id: null, apartment_id: null });
      } else {
        this.editTaskForm.patchValue({ property_id: null, contact_id: null });
      }
    }

    // If logos are not null, set the 'logos' field in the form
    if (this.logos !== null) {
      this.editTaskForm.patchValue({ logos: this.logos });
    }

    // Set the 'task_check_list' field in the form if 'checkList' has values
    let checkList = this.checkList?.length > 0 ? JSON.stringify(this.checkList) : null;
    this.editTaskForm.patchValue({ task_check_list: checkList });

    // If the title field is empty or contains only whitespace, show an error and reset it
    if (!this.editTaskForm.get('title').value.trim()) {
      this.toast.error('Please enter a valid title');
      this.editTaskForm.controls['title'].setValue(null);
      this.submit_btn_disabled = false;
      this.submitted = false;
      return;
    }

    // Prepare the form data to be submitted
    let form_data = this.editTaskForm.value;

    // Set the 'is_sub_task' field based on the 'parent_id' field value
    form_data['is_sub_task'] =
      this.editTaskForm.controls['parent_id'].value && this.editTaskForm.controls['parent_id'].value !== 'null' ? true : false;

    // Backend expects project ids, never project objects (422 otherwise)
    if (Array.isArray(form_data.project_id)) {
      form_data.project_id = form_data.project_id.map(p => (p && typeof p === 'object' ? p._id : p)).filter(Boolean);
    }

    // Make the API call to update the task
    this._taskService.updateTask(this.editId, form_data).subscribe({
      next: response => {
        // On successful submission, show a success message and reset relevant values
        this.toast.success('Task has been updated');
        this.getChildTaskList();
        this.logoUrl = [];
        this.logos = [];
        this.IsSavedClosed.emit(true);

        // If the state is not 'onlyUpdate', reset the form and close the task form
        if (state !== 'onlyUpdate') {
          this.IsSavedClosed.emit(false);
          this.lmService.is_new_task = false;
          this.editTaskForm.reset();
          this.closeAddTask();
        }

        // Reset the submit button and submission flag
        this.submit_btn_disabled = this.submitted = false;

        // Notify the dashboard about the form submission
        this.shareService.rightPropToDashboard.next(true);

        // Clear the validation error fields
        this.numOfNotValidFields = this.requiredErrorMessages.length = 0;

        // Attach the response attachments to the task after a short delay
        setTimeout(() => (this.tasks.attachments.data = response?.info?.value?.attachments), 2000);
      },

      error: error => {
        // On error, reset the submit button and submission flag
        this.submit_btn_disabled = this.submitted = false;

        // Set the error details and validate the fields
        this.error = Array.of(error.error.errors);
        let { fields, all_fields } = error?.error;

        // If there are fields that have errors, map and update them
        if (fields?.length > 0) {
          this.formalFields = fields = fields
            ?.map(error_field => {
              let isExistsField = all_fields?.find(field => field.name === error_field);
              if (isExistsField) {
                error_field = { name: error_field, label: isExistsField?.label || '' };
              }
              return error_field;
            })
            ?.filter(error_field => error_field !== undefined && error_field !== null && typeof error_field !== 'string');

          // Show an error message for required fields
          this.toast.error('Required fields must be filled in');

          // Validate the fields on request
          this.validateFieldsOnRequest(fields);
        } else {
          // If no specific fields are mentioned, show a generic error message
          this.toast.error('Something wrong with the form. Please check and try again');
        }
      },
    });
  }

  // Fetches the office staff information and sorts it
  getOfficeStaff() {
    // Define the URL to get the staff details by office ID
    const url = `/users/byoffice?office=${this.sds.getOfficeId()}&show=staff`;
    // Make the API call to fetch office staff data
    this.redux.getSetProjectInfo(true, 'byOffice', url).subscribe({
      next: ({ data }) => {
        // Create a copy of the data and format it by adding a full_name field
        let res = JSON.parse(JSON.stringify(data));
        this.originalAssigns = [...res].map(i => {
          i['full_name'] = i.first_name + ' ' + i.last_name;
          return i;
        });

        // Ensure the local user is included in the list of assigned staff
        if (!this.originalAssigns.some(user => user._id === this.localUser._id)) {
          this.originalAssigns.push(this.localUser);
        }

        // Sort the staff members by full name
        this.originalAssigns.sort((a, b) => (a.full_name || '').localeCompare(b.full_name || ''));

        // Store the sorted staff members in 'assigns'
        this.assigns = [...this.originalAssigns];
      },
    });
  }

  // Fetches a list of properties

  onUpdateMSelect = (eve: any, type: string) => {
    // re-multiselect emits the full object when it resolves preselected ids on load, but only the id on click
    const toId = (v: any) => (v && typeof v === 'object' ? v._id : v);
    let ids = type === 'project_id' ? (eve ? [toId(eve)] : null) : eve?.length > 0 ? eve.map(f => f._id) : null;
    this.editTaskForm.patchValue({ [type]: ids });
  };

  // Fetches property data

  // Fetches the activity logs for a specific task by ID
  getActivityLog() {
    // Make an API call to get activity logs for the task identified by 'editId'
    this._taskService.getActivityLogList(this.editId).subscribe({
      next: response => {
        // Filter the logs to include only those that have a 'heading' property
        this.logList = response.filter(l => l.hasOwnProperty('heading'));
      },
    });
  }

  // Fetches entity leads based on office ID and user ID
  getEntityLeads() {
    // Make an API call to fetch leads related to the entity
    this._sharedService.getDropDownItems('leads').subscribe({
      next: response => {
        // Store the fetched leads data in the 'leads' variable
        this.leads = response['data'];
      },
    });
  }

  // Handles changes to the selected project
  onChangeProject(event) {
    this.getApartmentByProject(event);
  }

  // Fetches apartments related to a specific project
  getApartmentByProject(projectid) {
    // If no project ID is provided, exit the function
    if (!projectid) {
      return;
    }
    // Make an API call to fetch apartments based on the provided project ID
    this._taskService.getProjectLot(projectid).subscribe({
      next: response => {
        // Store the fetched apartment data in the 'apartments' variable
        this.apartments = response['data'];
      },
    });
  }

  // Handles job type selection
  onJobType() {
    // Hide the leads section by default
    this.showLeads = false;

    // Iterate through job types and check if 'Lead Management' is selected
    this.jobTypes.forEach(jt => {
      if (jt.name == 'Lead Management' && jt._id == this.editTaskForm.controls['job_type_id'].value) {
        // If 'Lead Management' is selected, show the leads section
        this.showLeads = true;
      }
    });
  }
  allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
  // Handles logo file selection
  onLogoSelect(event) {
    // Initialize logos and logo URL arrays if not already initialized
    if (this.logos == null) {
      this.logos = [];
      this.logoUrl = [];
    }

    // If files are selected, process each file
    if (event.target.files && event.target.files.length) {
      for (let i = 0; i < event.target.files.length; i++) {
        let logoName = event.target.files[i].name;
        const file = event.target.files[i];
        const fileReader: FileReader = new FileReader();
        // ✅ Validate file type
        if (!this.allowedTypes.includes(file.type)) {
          this.toast.error(`Unsupported file format! Please upload a valid image`);
          continue; // Skip invalid files
        }
        // Read the file as a data URL
        fileReader.readAsDataURL(event.target.files[i]);
        fileReader.onload = () => {
          // Push the logo URL to the logoUrl array and the logo file to the logos array
          this.logoUrl.push(this.sanitizer.bypassSecurityTrustUrl(<any>fileReader.result));
          this.logos.push({ name: logoName, file: fileReader.result });
        };
      }
    }
  }

  // Clears the file input field
  clearFileInput() {
    // Get the file input element by its ID
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    // If the file input element is found, reset its value to clear the selected files
    if (fileInput) {
      fileInput.value = '';
    }
  }

  // Deletes a selected logo
  deleteLogo(logo) {
    this.remmiConfirm
      .delete({ title: 'Delete Attachment?', message: 'This file will be permanently deleted from the task.', subject: logo?.name })
      .subscribe(isConfirmed => {
        if (!isConfirmed) {
          return;
        }
        // Find the index of the logo in the attachments array and remove it
        const i = this.tasks.attachments.data.indexOf(logo);
        this.tasks.attachments.data.splice(i, 1);

        // Make an API call to delete the logo by its ID
        this._taskService.deleteTaskLogo(logo._id).subscribe({
          next: _ => {
            // On success, show a success message and clear the file input
            this.toast.success('File has been deleted');
            this.clearFileInput();
          },
        });
      });
  }

  // Calculates and updates the bill for a task based on the category and quantity
  getBill() {
    // Get the form controls to access the values
    const form = this.editTaskForm;

    // If the quantity is less than 0, convert it to a positive value
    if (form.controls['quantity'].value < 0) {
      form.controls['quantity'].setValue(form.controls['quantity'].value * -1);
    }

    // Filter the categories to find the selected category based on the task_category_id
    const myFilter = this.categories.filter(cat => cat.id === form.controls['task_category_id'].value);

    // If the selected category has printing costs of 0, show an error and disable the checkbox
    if (myFilter[0].printingCosts === 0) {
      this.toast.error('Please contact your office for printing rates');
      form.controls['isChecked'].setValue(true);
    } else {
      // If printing costs are available, calculate the bill based on the quantity and selected printing type
      this._taskService
        .bill(form.controls['printing_type_id'].value, form.controls['task_category_id'].value, form.controls['quantity'].value)
        .subscribe({
          next: response => {
            // If there's a discount, apply it to the calculated bill
            if (response.discount_percent > 0) {
              const orgBill = response.per_print * form.controls['quantity'].value;
              this.bill = orgBill - (orgBill * response.discount_percent) / 100;
            } else {
              // If no discount, just calculate the bill without discount
              this.bill = response.per_print * form.controls['quantity'].value;
            }

            // Uncheck the 'isChecked' checkbox after bill calculation
            form.controls['isChecked'].setValue(false);
          },
        });
    }
  }

  // Loads the list of comments associated with a specific task
  loadComments() {
    // Make an API call to fetch comments for the task identified by 'editId'
    this._taskService.getTaskComments(this.editId).subscribe({
      next: response => {
        // Assign the fetched comments data to the 'commentList' variable
        this.commentList = response.data;
      },
    });
  }

  // Saves a new comment for a specific task
  saveComments() {
    // Mark the comment as being submitted
    this.commentSubmit = true;

    // Make an API call to post the new comment for the task identified by 'editId'
    this._taskService.createTaskComments({ comments: this.comments, task_id: this.editId }).subscribe({
      next: _ => {
        // Show a success message when the comment is successfully published
        this.toast.success('Comment published');

        // Reset the comment input and mark the comment submission as complete
        this.comments = '';
        this.commentSubmit = false;

        // Reload the updated list of comments
        this.loadComments();
      },
    });
  }

  // Adds a new item to the checklist, or edits an existing item if one is being edited
  addCheckListItem() {
    // If an item is being edited (checkItemToEdit is not null), update it
    if (this.checkItemToEdit !== null) {
      this.checkList[this.checkItemToEdit] = this.newItem;
      // Reset the editing state after updating the item
      this.checkItemToEdit = null;
    } else {
      // If no item is being edited, add the new item to the checklist
      this.checkList.push(this.newItem);
    }

    // Clear the new item input after adding it
    this.newItem = '';
  }

  // Duplicates an existing task by sending a request to the server
  duplicateTask() {
    // Get the parent_id from the form control
    let parent_id = this.editTaskForm.controls['parent_id'].value;

    // Make an API call to duplicate the task with the provided editId and parentId
    this._taskService.duplicateTask(this.editId, parent_id).subscribe({
      next: response => {
        // If the duplication is successful, update the editId and reinitialize the task
        if (response.status) {
          this.editId = response?.result?._id;
          // Reinitialize the component with the new task ID
          this.editId && this.ngOnInit();
          this.toast.success('Task duplicated successfully');
        } else {
          // If there is an error, show the error message
          this.toast.error(response.message);
        }
      },
    });
  }

  // Formats the date and updates the corresponding form field based on the field name
  formatDates(event, field) {
    // Get the date string from the event using the Utils method
    let val = Utils.getDateStringFormat(event);

    // Check which field is being updated and patch the corresponding form control with the new date
    if (field === 'start_date') {
      this.editTaskForm.patchValue({
        start_date: new Date(val),
      });
    } else if (field === 'due_date') {
      this.editTaskForm.patchValue({
        due_date: new Date(val),
      });
    } else if (field === 'recurringEnds') {
      this.editTaskForm.patchValue({
        recurringEnds: new Date(val),
      });
    }
  }

  // Handles the drag-and-drop functionality for the checklist
  drop(event: CdkDragDrop<string[]>) {
    // Store the item being moved and the new position index
    const moveIt = this.checkList[event.previousIndex];
    const withId = event.currentIndex;

    // Swap the positions of the items in the checklist
    this.checkList[event.previousIndex] = this.checkList[withId];
    this.checkList[withId] = moveIt;
  }

  // Closes the add task modal and removes the level tab
  closeAddTask() {
    // Remove the level tab after closing the add task
    this.removeLevelTab();
  }

  // Removes a level tab and emits an update event with the tab data
  removeLevelTab() {
    // Find the tab level that contains 'Task' in its name and has data
    let tab = this.lmService.tab_levels.find(el => el.name.includes('Task') && el.data !== null);

    // If a tab is found, update the tab's taskTabs property and emit an update event
    if (tab) {
      let ind = this.lmService.tab_levels.indexOf(tab);
      tab['taskTabs'] = true;
      this.isUpdated.emit({ level: tab, index: ind });
    } else {
      // If no tab is found, emit a true value to indicate no tab removal
      this.isUpdated.emit(true);
    }
  }

  editRecord(record) {
    this.openRightModal(record, 'edit_contact');
  }

  // Opens a modal to edit or add information about a contact, task, or staff
  openRightModal(contact, addOrEdit) {
    // Reload the right bar
    this.lmService.reload_rightBar = false;

    // Handle the case when editing a contact
    if (addOrEdit == 'edit_contact') {
      if (this.isMobileDevice == true) {
        // Navigate to the office contact page if mobile view is enabled
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: contact?._id } });
      } else {
        // Set the mode to edit and add a tab for the contact
        this.lmService.isEdit_show_div = addOrEdit;
        let name = contact?.contact?.full_name || contact?.name || '';
        this.lmService.addTabInLevels(`Contact-${name}`, contact?._id, contact, null, 'contact');
        this.selectedContact = contact;
        this.lmService.cont_id = contact?._id;
        this.currentLeadIndex = this.lmService.Users?.indexOf(this.selectedContact);

        // Show the right bar after a slight delay
        setTimeout(() => {
          this.lmService.contact_showRightBar = true;
          this.lmService.reload_rightBar = true;
        }, 50);
      }
    }
    // Handle the case when editing a task
    else if (addOrEdit == 'edit_task') {
      this.lmService.addTabInLevels(`Task:` + ' REM-' + contact?.id, contact?._id, contact);
    }
    // Handle the case when adding or editing staff
    else if (addOrEdit == 'staff') {
      let name = contact?.contact?.full_name ? contact?.contact?.full_name : contact?.full_name ? contact?.full_name : '';
      this.lmService.addTabInLevels(`Staff-${name}`, contact?._id);
    }
    // Handle the case when adding a new contact
    else if (addOrEdit == 'add_contact') {
      if (this.isMobileDevice == true) {
        // Navigate to the office contact page if mobile view is enabled
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: 'createnew' } });
      } else {
        // Set the mode to add contact and show the right bar
        this.lmService.contact_show_div = addOrEdit;
        this.lmService.contact_showRightBar = true;
        this.lmService.addTabInLevels('Contact', 'new');
      }
    }
  }

  // Clears a staff or team member from the assigned list based on the method parameter
  clearStaff(item, method) {
    // Check if the method is 'staff', then work with the 'assignedUsers' control
    if (method == 'staff') {
      let localArray = [];
      localArray = this.editTaskForm.controls['assignedUsers'].value;

      // Loop through the array and remove the specified item
      localArray.forEach((x, i) => {
        if (x === item) {
          localArray.splice(i, 1); // Remove the item from the array
        }
      });

      // Set the updated value back to the assignedUsers form control
      this.editTaskForm.controls['assignedUsers'].setValue(localArray);
    } else {
      // If method is not 'staff', it works with the 'assignedTeams' control
      let localArray = [];
      localArray = this.editTaskForm.controls['assignedTeams'].value;

      // Loop through the array and remove the specified item
      localArray.forEach((x, i) => {
        if (x === item) {
          localArray.splice(i, 1); // Remove the item from the array
        }
      });

      // Set the updated value back to the assignedTeams form control
      this.editTaskForm.controls['assignedTeams'].setValue(localArray);
    }
  }

  // Fetches workflow processes for a given listing and updates the workflow service
  GetListingWorkflowProcesses() {
    // Set the workflow process tab as opened
    this._workflowService.isWorkflowProcessTabOpened = true;
    this._workflowService.ActiveProcessList = [];
    this._workflowService.processRecordId = this.editId;

    // Get all processes by module and filter based on the 'Tasks' module
    this._workflowService
      .GetAllProcessesByModule(this.editId, this._workflowService.module_array.filter(res => res.name === 'Tasks')?.[0]?.module_value)
      .subscribe(response => {
        try {
          const { status, data, meta } = response;
          if (status) {
            // If status is true, map the processes and capitalize the module names
            this._workflowService.ActiveProcessList = data?.map(
              result => (result = { ...result, module: Utils.capitalizePhrase(result?.module?.split('_')?.join(' ')?.trim() || '') })
            );

            // Update pagination information for the workflow processes
            this._workflowService.centralizedProcessPagination = {
              ...this._workflowService.centralizedProcessPagination,
              per_page: 10,
              total_pages: Math.ceil(meta?.pagination?.total / 10),
              total: meta?.pagination?.total,
              numberOfRecords: this._workflowService.ActiveProcessList?.length > 10 ? 10 : this._workflowService.ActiveProcessList?.length,
            };
          } else {
            // If status is false, reset the active process list
            this._workflowService.ActiveProcessList = [];
          }
        } catch (error) {
          // In case of any error, reset the active process list
          this._workflowService.ActiveProcessList = [];
        }
      });
  }

  // Validates fields on the request and sets required field validators dynamically
  validateFieldsOnRequest(fields: any[] = []) {
    if (fields?.length > 0) {
      // Loop through the fields and add validators for each required field
      fields?.forEach(field_error => {
        this.editTaskForm?.controls?.[field_error?.name]?.setValidators([Validators.required]);
        this.editTaskForm?.controls?.[field_error?.name]?.updateValueAndValidity(); // Update the form control validity
      });

      // Reset the error messages and invalid field counter
      this.numOfNotValidFields = this.requiredErrorMessages.length = 0;

      // Loop through the form controls to check for errors and populate error messages
      for (let prop in this.editTaskForm.controls) {
        if (this.editTaskForm.controls[prop].errors) {
          let fieldReqObj = {
            field: prop,
            message: `${fields?.find(templateField => templateField.name === prop)?.label || ''}`,
          };
          this.requiredErrorMessages.push(fieldReqObj); // Add the error message
          this.numOfNotValidFields++; // Increment the number of invalid fields
        }
      }
    }
  }

  // Activates the tab index based on the error message field and scrolls it into view
  ActivateTabIndexByError(message: string) {
    // Split the message into space-separated parts
    let space_separated: string[] = message?.split(' ');

    // Check if the first part of the message has a valid length
    if (space_separated?.[0]?.trim()?.length > 0) {
      // Try to find the form control by name, formControlName, or ID
      const element = this.formElementRef.nativeElement.querySelector(`[formControlName="${space_separated?.[0]?.trim()}"]`)
        ? this.formElementRef.nativeElement.querySelector(`[formControlName="${space_separated?.[0]?.trim()}"]`)
        : this.formElementRef.nativeElement.querySelector(`[name="${space_separated?.[0]?.trim()}"]`)
          ? this.formElementRef.nativeElement.querySelector(`[name="${space_separated?.[0]?.trim()}"]`)
          : this.formElementRef.nativeElement.querySelector(`[id="${space_separated?.[0]?.trim()}"]`);

      // If the element is found, scroll it into view with smooth behavior
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  // Opens the lead details either by navigating or fetching data based on the view mode (mobile or desktop)
  openLead = () => {
    // If there's no task, exit the function early
    if (!this._taskService) {
      return;
    }
    // Check if the mobile toggle is enabled, and navigate accordingly
    if (this.isMobileDevice == true) {
      this.router.navigate(['/leads'], { queryParams: { id: this.editTaskForm.get('lead_id').value } });
    } else {
      // If not mobile, fetch lead details via API and open it in a tab
      this._taskService.getLeadDetailById(this.editTaskForm.get('lead_id').value).subscribe({
        next: response => {
          let record = response.data;
          this.lmService.addTabInLevels('Lead' + ' - ' + record?.first_name + ' ' + record?.last_name, record?._id, record, null, 'lead');
        },
      });
    }
  };
}
